import { IAutoplaySetting } from "./AutoplaySettings";
import { types } from "./AutoplaySettings.actions";

export interface IAutoplaySettingsStateProps {
  available: boolean;
  allowAutoplayStart: boolean;
  running: boolean;
  roundsLeft: number;
  roundsSelected: number;
  settingsVisible: boolean;
  settings: {
    rounds: number[];
    settings?: any[];
  };
}

const defaultState: IAutoplaySettingsStateProps = {
  allowAutoplayStart: false,
  running: false,
  roundsLeft: null,
  roundsSelected: null,
  available: false,
  settings: {
    rounds: [],
    settings: []
  },
  settingsVisible: false
};

const isRequiredWithoutValue = (s: IAutoplaySetting) => {
  const isEmpty = (v: number | null) => !Boolean(v);

  if (s.attributes && s.attributes.required) {
    return isEmpty(s.attributes.value);
  }

  return false;
};

const isAutoplayAllowedToStart = (
  roundsSelected: number | null,
  settings: IAutoplaySetting[]
) => {
  // don't allow autoplay if rounds are not selected
  if (roundsSelected === null) {
    return false;
  }

  // don't allow autoplay if any setting is required and has no value.
  // note: a required setting is always treated as activated!
  const containsInvalid = settings.find(isRequiredWithoutValue);

  if (containsInvalid) {
    return false;
  }

  return true;
};

export const autoplay = (state = defaultState, action) => {
  switch (action.type) {
    case types.SET_AVAILABLE:
      return {
        ...state,
        available: action.value
      };
    case types.SHOW_ADVANCED_SETTINGS:
      return {
        ...state,
        settingsVisible: action.value
      };
    case types.SET_ADVANCED_SETTINGS:
      return {
        ...state,
        settings: {
          ...state.settings,
          settings: action.values
        },
        allowAutoplayStart: isAutoplayAllowedToStart(
          state.roundsSelected,
          action.values
        )
      };
    case types.UPDATE_ADVANCED_SETTING:
      const settings = state.settings.settings.map(item =>
        item.id === action.value.id ? action.value : item
      );

      return {
        ...state,
        settings: {
          ...state.settings,
          settings
        },
        allowAutoplayStart: isAutoplayAllowedToStart(
          state.roundsSelected,
          settings
        )
      };
    case types.SET_ROUNDS_VALUES:
      return {
        ...state,
        settings: {
          ...state.settings,
          rounds: action.values
        }
      };
    case types.SET_ROUNDS_LEFT:
      return {
        ...state,
        roundsLeft: action.value
      };
    case types.SELECT_ROUNDS:
      return {
        ...state,
        roundsSelected: action.value,
        roundsLeft: action.value,
        allowAutoplayStart: isAutoplayAllowedToStart(
          action.value,
          state.settings.settings
        )
      };
    case types.RESET_ROUNDS:
      return {
        ...state,
        roundsSelected: null,
        allowAutoplayStart: false,
        roundsLeft: null
      };
    case types.START_AUTOPLAY:
      return {
        ...state,
        running: true
      };
    case types.STOP_AUTOPLAY:
      return {
        ...state,
        running: false,
        roundsLeft: null,
        roundsSelected: null,
        allowAutoplayStart: false
      };
    default:
      return state;
  }
};
